import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../../TagNew';
import { tagThemeSmall } from '../../tag_theme';

export interface IRadioSelectTagItemProps {
  tag: { value: boolean | undefined };
  paramsDescription?: string;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const getRadioSelectionParamTagItem = (trueValue: string, falseValue: string) => (
  props: IRadioSelectTagItemProps,
) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {/* tslint:disable-next-line:prefer-template */}
      {(props.tag.value ? trueValue : falseValue) + ' ' + (props.paramsDescription || '')}
    </TagComponent>
  );
};
